module.exports = __webpack_public_path__ + "img/Stage_3_Diff.3e69cd11.jpg";